module.exports = __webpack_public_path__ + "static/media/referGiftIcon.c026477b.svg";